import React from 'react';
import TextInfo, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';
import {
  SHIPPING_TYPES_TEXT_DELIVERY,
  SHIPPING_TYPES,
} from '@/constants/operation';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import ShippingAddress from '@/containers/shipping/shippingAddress';
import ShippingAddressClient from '@/containers/shipping/shippingAddressClient';
import { SHIPPING_ADDRESS } from '@/constants/shippingAddress';
import ChooseDelivery from '@/containers/chooseDelivery';

function Shipping({
  control,
  getValues,
  unregister,
  resetField,
  shippingType = SHIPPING_TYPES.SHOP,
  shippingTitle = '',
  shippingText = '',
  defaultAddress = null,
  client = false,
  deliveryText = null,
  deliveryMethods = null,
  setValue = null,
  showForm = false,
  showDeliveryComponent = false,
  simSelected = true,
  esimText = null,
  defaultDeliveryMethod,
  portabilityText = null,
  simDeliveryTexts = null,
}) {
  return (
    <>
      {shippingType === SHIPPING_TYPES.DELIVERY && client && (
        <div className="shipping-container">
          <ShippingAddressClient
            label={SHIPPING_TYPES_TEXT_DELIVERY}
            unregister={unregister}
            control={control}
            getValues={getValues}
            resetField={resetField}
            componentName="SHIPPING_ADDRESS"
            defaultAddress={defaultAddress}
            deliveryText={deliveryText}
            setValue={setValue}
          />
        </div>
      )}
      {shippingType === SHIPPING_TYPES.DELIVERY && !client && (
        <div className="shipping-container">
          <ShippingAddress
            title="Entrega eSIM o SIM"
            label={SHIPPING_TYPES_TEXT_DELIVERY}
            unregister={unregister}
            control={control}
            getValues={getValues}
            resetField={resetField}
            formStructure={SHIPPING_ADDRESS}
            componentName="SHIPPING_ADDRESS"
            setValue={setValue}
          />
        </div>
      )}
      {showDeliveryComponent && (
        <ChooseDelivery
          control={control}
          showForm={showForm}
          title={shippingTitle || 'Entrega SIMs'}
          deliveryMethods={deliveryMethods}
          shippingText={shippingText}
          simSelected={simSelected}
          esimText={esimText}
          portabilityText={portabilityText}
          defaultDeliveryMethod={{ value: defaultDeliveryMethod }}
          simDeliveryTexts={simDeliveryTexts}
        />
      )}
      {(shippingTitle || shippingText) && !showDeliveryComponent && (
        <div className="choose-operation__shipping-container">
          <FormTemplate titleText={shippingTitle} theme={THEMES.LONG}>
            <TextInfo
              text={shippingText}
              color={TEXT_COLOR.GREY5}
              size={TEXT_SIZE.CAPTION1}
            />
          </FormTemplate>
        </div>
      )}

      <style jsx>
        {`
          .shipping-container,
          .choose-operation__shipping-container {
            margin-bottom: 12px;
          }
          :global(.choose-operation__shipping-container ul) {
            list-style: none;
          }
        `}
      </style>
    </>
  );
}
export default Shipping;
